import React from 'react';

const GradientStops = ({ id, stops, vertical = false }) => (
  <linearGradient id={id} x1="0%" y1="0%" x2={vertical ? '0%' : '100%'} y2="100%">
    {stops.map(([offset, color, opacity]) => (
      <stop key={offset} offset={offset} stopColor={color} stopOpacity={opacity} />
    ))}
  </linearGradient>
);

export const LogoGradients = () => (
  <defs>
    <GradientStops id="bgGrad" stops={[['0%', '#FF6B35'], ['50%', '#F7931E'], ['100%', '#4ECDC4']]} />
    <GradientStops id="ringGrad" stops={[['0%', '#FF6B35', 0.9], ['50%', '#FFD93D', 0.9], ['100%', '#4ECDC4', 0.9]]} />
    <GradientStops id="textGrad" stops={[['0%', '#FFD93D'], ['50%', '#FF6B35'], ['100%', '#F7931E']]} />
  </defs>
);

export const RocketGradient = () => (
  <defs>
    <GradientStops id="rocketGrad" vertical stops={[['0%', '#F7931E'], ['50%', '#FF6B35'], ['100%', '#E85D04']]} />
  </defs>
);
